import { Component, OnInit, ChangeDetectorRef, ElementRef, Inject, PLATFORM_ID, Renderer2, Optional, InjectionToken, DestroyRef, inject, AfterViewInit } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { GlobalcontentModel } from '@app/models/content/GlobalcontentModel';
import { GlobalcontentService } from '@app/services/globalcontent.service';
import { BehaviorSubject } from 'rxjs';
import { CommonModule, DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleService } from '@app/services/google.service';
import { PARTNER_TOKEN } from 'tockens';
import { ContenteditorComponent } from '../contenteditor/contenteditor.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { REQUEST } from 'browsertockens';
const STATE_KEY_ITEMS = makeStateKey('datas');
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [
        CommonModule,
        ContenteditorComponent
    ]
})
export class HomeComponent implements OnInit, AfterViewInit {
    destroyRef = inject(DestroyRef);
    datas: GlobalcontentModel;
    partnerid: string = '';
    schema: any = {};
    constructor(
        protected guardService: AuthGuardService,
        protected metaService: Meta,
        protected titleService: Title,
        protected cdr: ChangeDetectorRef,
        protected elem: ElementRef,
        protected globalcontentService: GlobalcontentService,
        protected route: ActivatedRoute,
        protected router: Router,
        @Inject(PLATFORM_ID) protected platformId: any,
        protected _renderer2: Renderer2,
        protected googleService: GoogleService,
        @Inject(DOCUMENT) protected document: any,
        protected state: TransferState,
        @Optional() @Inject(REQUEST) private request: any,
        @Optional() @Inject(PARTNER_TOKEN) private partner_id: InjectionToken<string>,
    ) {
        if (isPlatformServer(this.platformId)) {
            this.partnerid = this.partner_id.toString();
        }
    }

    ngOnInit(): void {
        if(isPlatformServer(this.platformId)) {
            // console.log(this.request.headers.cookie);
        }
        this.getcontents();
        this.checkPartner();
    }

    checkPartner():void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res.nositemap) {
                this.metaService.updateTag({ name: 'robots', content: 'noindex,follow,max-image-preview:large,noodp,noydir' });
            } else {
                this.metaService.updateTag({ name: 'robots', content: 'index,follow,max-image-preview:large,noodp,noydir' });
            }
        });
    }

    async getcontents() {
        this.datas = this.state.get(STATE_KEY_ITEMS, <any>{});
        this.state.set(STATE_KEY_ITEMS, <any>{}); // remove content for next loading
        if (!this.datas?.elements && this.partnerid?.length > 0) {
            this.globalcontentService.request({ partnerid: this.partnerid }, 'getstartsite').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe((res) => {
                if (res?.globalcontentid?.length > 0) {
                    this.datas = res;
                    if (isPlatformServer(this.platformId)) {
                        this.state.set(STATE_KEY_ITEMS, <any>this.datas);
                    }
                    if (isPlatformBrowser(this.platformId)) {
                        this.incview(res?.globalcontentid);
                    }
                    this.addTags(this.datas?.meta);
                    this.setExtraScript(this.datas?.extraScript);
                    this.cdr.detectChanges();
                }
            });
        } else if (this.datas?.elements && this.partnerid?.length > 0) {
            if (isPlatformBrowser(this.platformId)) {
                this.setExtraScript(this.datas?.extraScript);
                this.incview(this.datas?.globalcontentid);
            }
        }
    }

    incview(gbid): void {
        this.globalcontentService.request({ partnerid: this.partnerid, globalcontentid: gbid }, 'incview').pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((_) => {});
    }

    initContent(res): void {
        if (res?.globalcontentid?.length > 0) {
            this.datas = res;
            if (isPlatformServer(this.platformId)) {
                this.state.set(STATE_KEY_ITEMS, <any>this.datas);
            }
            this.addTags(this.datas?.meta);
            if (isPlatformBrowser(this.platformId)) {
                this.setExtraScript(this.datas?.extraScript);
            }
            this.cdr.detectChanges();
        }
    }

    setExtraScript(extraScript: string): void {
        this.googleService.gTagIsCreated$().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((isCreated) => {
            if (isCreated && extraScript?.length > 0) {
                const exScript = this._renderer2.createElement('script');
                exScript.text = extraScript.trim().replaceAll('\n', '').replaceAll('<script>', '').replaceAll('</script>', '');
                this._renderer2.appendChild(this.document.body, exScript);
            }
        });
    }

    updateCanonicalUrl(url: string) {
        if (url?.length > 0) {
            const head = this.document.getElementsByTagName('head')[0];
            let element = this.document.querySelector('link[rel=\'canonical\']') || null;
            if (element == null) {
                element = this.document.createElement('link');
                head.appendChild(element);
            }
            element.setAttribute('rel', 'canonical');
            element.setAttribute('href', url);
        }
    }

    ngAfterViewInit(): void {
        if (this.datas?.scriptdata?.length > 0) {
            const cleverscript = this.document.getElementById('clever-custom-content-script');
            if (cleverscript) {
                setTimeout(() => {
                    var newScript = this.document.createElement("script");
                    newScript.textContent = this.datas?.scriptdata;
                    newScript.id = 'clever-custom-content-script';
                    this.document.body.replaceChild(newScript, cleverscript);
                }, 100);
            }
        }
    }

    addTags(metaData?) {
        if (this.datas?.cssdata?.length > 0) {
            const cleverstyle = this.document.getElementById('clever-custom-content-style');
            if (cleverstyle) {
                cleverstyle.innerText = this.datas?.cssdata.replaceAll('\n', '');
            }
        }
        const url = new URL(this.document.URL);
        this.metaService.updateTag({ property: 'og:type', content: 'article' });
        this.metaService.updateTag({ property: 'og:title', content: metaData?.title });
        this.metaService.updateTag({ name: 'url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
        this.updateCanonicalUrl(String(url.origin + url.pathname).replace(/http:/, 'https:'));
        this.metaService.updateTag({ property: 'og:site_name', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
        this.metaService.updateTag({ property: 'og:url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
        if (metaData?.description?.length > 0) {
            this.metaService.updateTag({ name: 'description', content: metaData.description });
            this.metaService.updateTag({ property: 'og:description', content: metaData.description });
        }
        if (metaData?.keywords?.length > 0) {
            this.metaService.updateTag({ name: 'keywords', content: metaData.keywords });
        }
        this.schema = {
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            name: metaData?.title,
            description: metaData?.description,
            keywords: metaData?.keywords,
        };
        this.globalcontentService.loadjsonld(this.schema);
        if(this.datas?.sdata) {
            if(this.datas?.sdata) {
                try {
                    this.globalcontentService.loadjsonld(JSON.parse(this.datas?.sdata));
                } catch(error) {
                    console.log(error)
                }
            }
        }
        if (metaData?.title?.length > 0) {
            this.titleService.setTitle(metaData?.title);
        } else {
            this.titleService.setTitle('');
        }
    }
}
